import React from 'react';
import styles from './TasksSheet.module.css';
import TaskProgress from './TaskProgress';
import TaskList from './TaskList';

// Mobile tasks sheet: peeks up from the bottom of the canvas, expands to
// ~85% height when the handle is tapped. The selected oval's row is put
// first by the caller.
const TasksSheet = ({tasks, selectedTaskId, onSelectTask, expanded, onToggleExpand, onOpenPageDetails}) => (
    <section aria-labelledby="mobile-tasks-heading" className={`${styles.sheet} ${expanded ? styles.expanded : ''}`}>
        <button
            type="button"
            aria-label="Expand tasks panel"
            aria-expanded={expanded}
            className={styles.handleButton}
            onClick={onToggleExpand}
        >
            <span className={styles.handle}/>
        </button>
        <div className={styles.header}>
            <div className={styles.headerLeft}>
                <h2 id="mobile-tasks-heading" className={styles.heading}>Tasks</h2>
                <span className={styles.count}>{tasks.length} oval{tasks.length === 1 ? '' : 's'}</span>
            </div>
            <button type="button" className={styles.detailsButton} onClick={onOpenPageDetails}>
                Page details
            </button>
        </div>
        <div className={styles.progressWrap}>
            <TaskProgress tasks={tasks}/>
        </div>
        <div className={styles.listWrap}>
            <TaskList tasks={tasks} selectedTaskId={selectedTaskId} onSelectTask={onSelectTask}/>
        </div>
    </section>
);

export default TasksSheet;
